import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const projects = [
  {
    id: "1",
    title: "Hôtel de la Zoologie",
    description: "Bordeaux France 2021",
    details: "Réaliser en 2021",
    images: "/media/projet/hotelZoologie/zz3.avif",
  },
  {
    id: "2",
    title: "Sébastopol",
    description: "Paris France 2024",
    details: "Détails complets du projet 2, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/sebasto/m18.jpg",
  },
  {
    id: "3",
    title: "Maison à Saint-Tropez",
    description: "Saint-Tropez France 2022",
    details: "Détails complets du projet 3, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/stTropez/st2.jpg",
  },
  {
    id: "4",
    title: "Maison à Comporta",
    description: "Maison à Comporta au Portugal 2021",
    details: "Détails complets du projet 4, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/comporta/co3.jpg",
  },
  {
    id: "5",
    title: "Maison à Cabris",
    description: "Maison à Cabris 2025",
    details: "Détails complets du projet 5, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/Cabris/image1.jpg",
  },
  {
    id: "6",
    title: "Bar le Chaudron",
    description: "Bar La Rochelle 2025",
    details: "Détails complets du projet 6, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/bar/barfini3.png",
  },
  {
    id: "7",
    title: "Rue de la paix",
    description: "Rue de la paix Paris 2025",
    details: "Détails complets du projet 7, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/paix/paix3.jpg",
  },
  {
    id: "8",
    title: "Domaine de Bagatelle",
    description: "Château de Bagatelle Mareuil 2026",
    details: "Détails complets du projet 8, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/bagatelle/chambre/IMG_9374.jpg",
  },
  {
    id: "9",
    title: "Champagne Thiénot",
    description: "Cave Champagne Thiénot Reims 2026",
    details: "Détails complets du projet 9, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/thienot/salon.JPG",
  },
  {
    id: "10",
    title: "Camping Serignan",
    description: "Camping Serignan 2026",
    details: "Détails complets du projet 9, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/campingSerignan/19.jpg",
  },
  {
    id: "11",
    title: "Château de Montmoreau",
    description: "Château de Montmoreau 2016",
    details: "Détails complets du projet 9, expliquant en profondeur ce qui a été fait.",
    images: "/media/projet/chateauMontmoreau/image.jpg",
  },
];

const Projects = () => {
  const { t } = useTranslation();
  return (
    <div className="projet-class">
      <div data-aos="fade-up" className="projet-class-box">
        <h1>{t("text30")}</h1>
        <p>{t("text31")}</p>
        <button>{t("text32")}</button>
      </div>
      <div data-aos="fade-up" className="projet-class-content">
        <div className="projet-class-content-title">
          <p>{t("text33")}
          </p>
        </div>
        <div className="projet-class-content-projet">
          <ul>
              {projects.map((project) => (
                <li key={project.id}>
                  <img src={project.images} alt={project.title}></img>
                  <h2>{project.title}</h2>
                  <p>{project.description}</p>
                  <Link className="link-projet" to={`/projects/${project.id}`}>{t("text34")}</Link>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Projects;
